<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" :class="this.$store.state.isRTL ? 'top-0 position-sticky z-index-sticky' : ''
    " v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" textWhite="text-white" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'" id="navbar">
        <div class="pe-md-3 d-flex align-items-center" :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'">
          
        </div>
        <ul class="navbar-nav justify-content-end">
          <li
            class="nav-item d-flex align-items-center pe-2"
          >
            <a
              href="#"
              class="p-0 nav-link text-white me-2 iconClass"
              :class="[showMenu ? 'show' : '']"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showMenu = !showMenu"
              @blur="closeMenu"              
            >
              <i class="cursor-pointer fa fa-bell"></i>
              <span v-text="totalUnreadNotif()"></span>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end shadow position-absolute mt-0 me-3"
              :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton"
              v-if="totalNotif() > 0"
              style="max-width: 400px;"
            >
              <li>
                <div class="d-flex align-items-center justify-content-between py-1 px-2">
                  <argon-button color="danger" size="xs" class="ms-auto"  @click="deleteAllNotif()"
                  >Delete All</argon-button>
                  <argon-button color="success" size="xs" class="ms-auto" @click="readAllNotif()"
                  >Read All</argon-button>
                </div>
                <hr />
              </li>
              <li v-for="(item, key) in localNotif()" :key="key" @click="readNotif(item)">
                <div class="py-1 d-flex dropdown-item border-radius-md">
                  <div
                    class="my-auto avatar avatar-xs bg-gradient-secondary me-3"                  
                  >
                    <i class="cursor-pointer fa fa-bell"></i>
                  </div>
                  <div class="d-flex flex-column justify-content-center w-100">
                    <div class="row">
                      <div class="col">
                        <h6 class="mb-1 text-sm" :class="item.is_read ? 'font-weight-normal' : 'font-weight-bold'" v-text="item.title"/>
                      </div>
                      <div class="col">
                        <p class="mb-1 mt-1 text-xs text-secondary" style="text-align: right;" v-text="dateTime(Date.parse(item.created_at))"/>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <h6 class="mb-1 text-xs text-wrap" :class="item.is_read ? 'font-weight-normal' : 'font-weight-bold'" v-text="item.message"/>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </li>
            </ul>
            <ul
              class="dropdown-menu dropdown-menu-end shadow position-absolute mt-0"
              :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton"
              v-else
            >
             
              <li >
                  <div class="py-1 d-flex dropdown-item border-radius-md">
                    <div
                      class="my-auto avatar avatar-xs bg-gradient-secondary me-2"
                    >
                      <i class="cursor-pointer fa fa-envelope"></i>
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        you have no notification yet
                      </h6>
                    </div>
                  </div>
              </li>
            </ul>
          </li>
          <li v-if="loggedIn" class="nav-item d-flex align-items-center">
            <a id="dropdownProfileMenu" href="#" style="display: contents;"
              :class="`nav-link ${showProfileDropdown ? 'show' : ''}`" data-bs-toggle="dropdown" aria-expanded="false"
              @click="showProfileDropdown = !showProfileDropdown">
              <span class="avatar avatar-sm rounded-circle">
                <img :src="profileImage()" style="object-fit: cover !important;">
              </span>
              <span v-if="this.$store.state.isRTL" class="d-sm-inline d-none text-white p-2">{{ getNameNavbar }}</span>
              <span v-else class="d-sm-inline d-none text-white p-2">{{ getNameNavbar }}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow position-absolute mt-0"
              :class="showProfileDropdown ? 'show' : ''" aria-labelledby="dropdownProfileMenu">
              <div class="border-radius-md" style="padding: 0.3rem 1rem;">
                <small>
                  Welcome
                </small>                
              </div>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div>
                    <i class="ni ni-circle-08"></i>
                    <router-link :to="{ name: 'User Profile' }" class="ms-2">My Profile</router-link>
                  </div>
                </a>
              </li>
              <hr class="m-2">
              <li>
                <a class="dropdown-item border-radius-md cursor-pointer" @click.prevent="handleLogout">
                  <div>
                    <i class="ni ni-user-run"></i>
                    <span class="ms-2">Logout</span>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import placeholder from "../../assets/img/placeholder.jpg";
import showSwal from "../../mixins/showSwal.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import NotificationService from "@/services/notifications.service.js";
import ArgonButton from "@/components/ArgonButton.vue";
import SoundUrl from "@/assets/notification-ring.mp3";


const moment = require('moment');
const toastId = ref('');


export default {
  name: "navbar",
  components: {
    Breadcrumbs,
    ArgonButton,

  },
  data() {
    return {
      websocket: null,
      showMenu: false,
      // notifCount: 0,
      showProfileDropdown: false
    };
  },
  props: ["minNav", "textWhite"],
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    loggedIn() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    getProfileNavbar() {
      return this.$store.getters["profile/me"];
    },
    getNameNavbar() {
      return this.getProfileNavbar?.name
    },
    getImageNavbar() {
      return this.getProfileNavbar?.profile_image;
    },
  },
  mixins: [showSwal],
  created() {
    this.minNav;
  },
  mounted() {
    if(this.loggedIn){
      this.getAllNotification()
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    profileImage() {
      return this.getImageNavbar ? this.getImageNavbar : placeholder;
    },
    playSound() {
      var audio = new Audio(SoundUrl);
      audio.play();      
    },
    async handleLogout() {
      try {
        await this.$store.dispatch("auth/logout");
      } finally {
        await this.$router.push({ name: "Login" });
      }
    },

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },

    dateTime(value) {
      return moment(value).format("DD-MM-YYYY HH:mm");
    },

    localNotif() {
      var notifications = localStorage.getItem('backoffice-notif');
      if(notifications != null){
        return JSON.parse(notifications)
      }
      return []
    },
    totalNotif() {
      var notifications = localStorage.getItem('backoffice-notif');
      if(notifications != null){
        return JSON.parse(notifications).length
      }else{
        return 0
      }
    },
    totalUnreadNotif() {
      var notifications = localStorage.getItem('backoffice-notif');
      if(notifications != null){
        return JSON.parse(notifications).filter(e => !e.is_read).length 
      }else{
        return 0
      }
    },

    initChat() {
      var sockets_bay_url = `${process.env.VUE_APP_WS_BASE_URL}?user_id=${process.env.VUE_APP_WS_ADMIN_EMAIL}`;
      this.websocket      = new WebSocket(sockets_bay_url);
      //
      this.websocket.onopen    = this.onSocketOpen;
      this.websocket.onmessage = this.onSocketMessage;
      this.websocket.onerror   = this.onSockerError;
      this.websocket.onclose   = this.onSocketClose;
    },
    onSocketOpen(){
      this.connection_ready = true;
    },
    onSocketClose(evt){
      
      setTimeout(() => {
        console.log(evt)      
        this.initChat()
      }, 3000);
    },
    onSocketMessage(evt){      
      console.log(evt)
      
      var received = JSON.parse(evt.data);
      if(received.eventName == "message response"){
        toastId.value = toast.success(received.message);
        
        var notifications = localStorage.getItem('backoffice-notif');
        var array = []

        if(notifications != null){
          array = JSON.parse(notifications);
          array.push({message: received.message, created_at: Date()})
        }else{
          array.push({message: received.message, created_at: Date()})
        }
        localStorage.setItem('backoffice-notif', JSON.stringify(array))
        this.totalNotif()
        this.playSound()
      }
    },

    onSockerError(evt){
      console.log(evt)

      this.connection_error = true;
    },  
    getAllNotification() {
      const params = {
        limit: 50
      }
      NotificationService.getAll(params).then(e => {
        const data = (e.data && e.data.notifications) || []
        localStorage.setItem('backoffice-notif', JSON.stringify(data))
        this.initChat()
      })
    },
    readNotif(item) {
      NotificationService.read(item.id).then(e => {
        console.log(e)
        var notifications = localStorage.getItem('backoffice-notif');
        var array = JSON.parse(notifications);
        let index = array.findIndex(product => product.id === item.id);
        array[index].is_read = true;
        localStorage.setItem('backoffice-notif', JSON.stringify(array))
        this.totalUnreadNotif()
       
        if(item.target_type == "NEW_USER_REGISTER") {
          document.location = `/external-users/${item.target_id}`
        }else if(item.target_type == "USER_KYC") {
          document.location = `/external-users/${item.target_id}`
        }else if(item.target_type == "USER_BUY_PRODUCT") {
          document.location = `/invoices/${item.target_id}/edit`
        }else if(item.target_type == "PRODUCT_WILL_EXPIRE") {
          document.location = `/subscriptions/${item.target_id}/edit`
        }
      })
    },

    readAllNotif() {
      NotificationService.readAll().then(e => {
        console.log(e)
        var notifications = localStorage.getItem('backoffice-notif');
        var array = JSON.parse(notifications);
        array = array.map(product => {
          product.is_read = true;
          return product;
        });
        localStorage.setItem('backoffice-notif', JSON.stringify(array))
        this.totalUnreadNotif()
      })
    },

    deleteAllNotif() {
      NotificationService.deleteAll().then(e => {
        console.log(e)
        localStorage.setItem('backoffice-notif', JSON.stringify([]))
        this.totalUnreadNotif()
        this.totalNotif()
      })
    }
  },
};
</script>
